import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { capturePushLink } from "@/lib/pushLink";
import { markDisplayMode } from "@/lib/pwa";

// Cattura il riferimento della timbratura suggerita da un'eventuale push, prima del routing.
capturePushLink();
// Segna su <html> se Orbit è avviata come app installata (standalone) e su quale piattaforma.
markDisplayMode();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Registrazione PWA service worker (network-only, nessuna cache aggressiva).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
